<template>
  <div v-if="sortedData.length" class="timeline">
    <div class="timeline__item" v-for="item in sortedData" :key="item._id">
      <div class="content">
        <h2 v-if="item.title.length" class="text-success">
          {{ item.title }}
        </h2>
        <h4 v-if="item.text.length">{{ item.text }}</h4>
        <p v-if="item.description.length">
          {{ item.description }}
        </p>
        <div v-if="item.tags.length">
          <b-badge
            pill
            v-for="tag in item.tags"
            :key="tag"
            variant="danger mr-1"
            >{{ tag }}</b-badge
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalTimeline",
  props: {
    inputData: {
      type: Array,
      required: true,
      default: () => [],
    },
    reversed: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    sortedData() {
      const inputData = this.inputData;
      inputData.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      if (this.reversed) inputData.reverse();
      return inputData;
    },
  },
};
</script>

<style scoped lang="scss">
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  & * {
    box-sizing: border-box;
  }
  &::after {
    content: "";
    position: absolute;
    width: 6px;
    background-color: $primary;
    top: 0;
    bottom: 0;
    left: 90%;
    margin-left: -3px;
    border-radius: 3px;
    @media screen and (min-width: 1024px) {
      left: 50%;
    }
  }
  &__item {
    padding: 10px 40px;
    position: relative;
    background-color: inherit;
    width: 90%;
    @media screen and (min-width: 1024px) {
      width: 50%;
    }
    &::after {
      content: "";
      position: absolute;
      width: 25px;
      height: 25px;
      right: -13px;
      background-color: $primary;
      border: 6px solid $primary;
      top: calc(50% - 16px);
      border-radius: 50%;
      z-index: 1;
      @media screen and (min-width) {
        top: calc(50% - 16px);
      }
    }
    &:nth-child(odd) {
      left: 0;
      @media screen and (min-width: 520px) {
      }
      .content {
        @media screen and (min-width: 520px) {
          padding: 20px 50px 20px 30px;
          margin-right: 60px;
        }
      }
    }
    &:nth-child(even) {
      @media screen and (min-width: 520px) {
      }
      @media screen and (min-width: 1024px) {
        left: 50%;
      }
      .content {
        @media screen and (min-width: 520px) {
          padding: 20px 50px 20px 30px;
          margin: 0 60px 0 0;
        }
        @media screen and (min-width: 1024px) {
          padding: 20px 30px 20px 50px;
          margin: 0 0 0 60px;
        }
      }
      &::after {
        @media screen and (min-width: 1024px) {
          left: -13px;
        }
      }
    }
  }
  .content {
    position: relative;
    &__heading {
      color: $secondary;
    }
    &__date {
      font-style: italic;
    }
  }
}
</style>
